import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = { class: "form-wrapper template-page-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "meeting-menu-empty",
  style: {"margin-bottom":"20px"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "template-item-name" }
const _hoisted_8 = { class: "template-item-head-right" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "template-item-body"
}
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "meeting-form-row" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { style: {"flex":"0 0 auto"} }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "template-col-row" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "crm-board-color-select" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "template-col-items" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "template-col-links" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "template-section-top" }
const _hoisted_31 = { class: "template-section-num" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "template-section-bottom" }
const _hoisted_34 = { class: "template-section-time" }
const _hoisted_35 = { class: "template-section-time-input" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "template-section-desc" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "template-section-shows" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Meeting Templates")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/meetings')))
        }, "Back")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, [
          _createTextVNode(" Templates show up when someone clicks "),
          _createElementVNode("b", null, "+ New Meeting"),
          _createTextVNode(". Picking one prefills the meeting's name, board columns (with any default items below), and agenda sections - the color is only used for its dot in that list. ")
        ], -1)),
        (!_ctx.templates.length && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No templates yet - add one below."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (t, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: t.ID || `new-${i}`,
            class: "template-item"
          }, [
            _createElementVNode("div", {
              class: "template-item-head",
              onClick: ($event: any) => (_ctx.toggleOpen(i))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(t.Name || '(untitled template)'), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _withModifiers(($event: any) => (_ctx.onDeleteTemplateClick(t)), ["stop"]),
                  class: "template-delete-icon",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24"
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                ]))], 8, _hoisted_9)),
                _createElementVNode("span", {
                  class: _normalizeClass(["template-chevron", _ctx.openIndex == i ? 'open' : ''])
                }, "▸", 2)
              ])
            ], 8, _hoisted_6),
            (_ctx.openIndex == i)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[18] || (_cache[18] = _createElementVNode("h3", {
                    class: "meeting-form-label",
                    style: {"margin-top":"0"}
                  }, "Template name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((t.Name) = $event),
                    placeholder: "Template name"
                  }, null, 8, _hoisted_11), [
                    [_vModelText, t.Name]
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "meeting-form-label" }, "Description", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((t.Description) = $event),
                        placeholder: "Shown under the name in the picker"
                      }, null, 8, _hoisted_13), [
                        [_vModelText, t.Description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "meeting-form-label" }, "Color", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "color",
                        "onUpdate:modelValue": ($event: any) => ((t.Color) = $event)
                      }, null, 8, _hoisted_15), [
                        [_vModelText, t.Color]
                      ])
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "meeting-form-label" }, [
                    _createTextVNode("Board columns "),
                    _createElementVNode("span", { class: "meeting-form-hint" }, "(with any default items to start the board with)")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Columns, (col, ci) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "template-col-block",
                      key: ci
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((col.name) = $event),
                          placeholder: "Column name"
                        }, null, 8, _hoisted_17), [
                          [_vModelText, col.name]
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((col.color) = $event),
                            "aria-label": "Column color"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, k) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: k,
                                value: color.hex
                              }, _toDisplayString(color.label), 9, _hoisted_20))
                            }), 128))
                          ], 8, _hoisted_19), [
                            [_vModelSelect, col.color]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "color",
                            "onUpdate:modelValue": ($event: any) => ((col.color) = $event),
                            title: "Custom color"
                          }, null, 8, _hoisted_21), [
                            [_vModelText, col.color]
                          ])
                        ]),
                        _createVNode(_component_svg_icon, {
                          icon: "x",
                          class: "template-remove",
                          onClick: ($event: any) => (col.items.length ? (_ctx.columnPendingRemoval = { t, col }) : t.Columns.splice(ci, 1))
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.items, (item, ii) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "template-col-item-row",
                            key: ii
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              placeholder: "Item name"
                            }, null, 8, _hoisted_23), [
                              [_vModelText, item.name]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                              placeholder: "Description"
                            }, null, 8, _hoisted_24), [
                              [_vModelText, item.description]
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((item.priority) = $event)
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("option", { value: null }, "No Priority", -1),
                              _createElementVNode("option", { value: "high" }, "High", -1),
                              _createElementVNode("option", { value: "med" }, "Medium", -1),
                              _createElementVNode("option", { value: "low" }, "Low", -1)
                            ]))], 8, _hoisted_25), [
                              [_vModelSelect, item.priority]
                            ]),
                            _createVNode(_component_svg_icon, {
                              icon: "x",
                              class: "template-remove",
                              onClick: ($event: any) => (col.items.splice(ii, 1))
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128)),
                        _createElementVNode("div", {
                          class: "template-addlink template-addlink-sm",
                          onClick: ($event: any) => (col.items.push({ name: '', description: '', priority: null }))
                        }, "+ Add Item", 8, _hoisted_26)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", {
                      class: "template-addlink",
                      onClick: ($event: any) => (t.Columns.push({ name: '', color: _ctx.NEW_COLUMN_COLOR, show: true, items: [] }))
                    }, "+ Add Column", 8, _hoisted_28),
                    (t.Columns.length)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "template-addlink",
                          onClick: ($event: any) => (_ctx.applyDefaultColumnColors(t.Columns, _ctx.$store.state.colorPalette))
                        }, "Apply Default Colors", 8, _hoisted_29))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "meeting-form-label" }, [
                    _createTextVNode("Sections "),
                    _createElementVNode("span", { class: "meeting-form-hint" }, "(set a time limit for each)")
                  ], -1)),
                  _createVNode(_component_draggable, {
                    modelValue: t.Sections,
                    "onUpdate:modelValue": ($event: any) => ((t.Sections) = $event),
                    handle: ".template-section-handle"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Sections, (section, si) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "template-section-row",
                          key: si
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", {
                              class: "template-section-handle",
                              title: "Drag to reorder"
                            }, "⋮⋮", -1)),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(si + 1), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((section.name) = $event),
                              placeholder: "Section name"
                            }, null, 8, _hoisted_32), [
                              [_vModelText, section.name]
                            ]),
                            _createVNode(_component_svg_icon, {
                              icon: "x",
                              class: "template-remove",
                              onClick: ($event: any) => (t.Sections.splice(si, 1))
                            }, null, 8, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "meeting-form-sublabel" }, "Time Limit", -1)),
                              _createElementVNode("div", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  min: "0",
                                  "onUpdate:modelValue": ($event: any) => ((section.minutes) = $event)
                                }, null, 8, _hoisted_36), [
                                  [
                                    _vModelText,
                                    section.minutes,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _cache[12] || (_cache[12] = _createElementVNode("span", null, "min", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "meeting-form-sublabel" }, "Description", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((section.description) = $event),
                                placeholder: "Description"
                              }, null, 8, _hoisted_38), [
                                [_vModelText, section.description]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((section.showScorecard) = $event)
                              }, null, 8, _hoisted_40), [
                                [_vModelCheckbox, section.showScorecard]
                              ]),
                              _cache[15] || (_cache[15] = _createTextVNode("Show the team's scorecard", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((section.showRocks) = $event)
                              }, null, 8, _hoisted_41), [
                                [_vModelCheckbox, section.showRocks]
                              ]),
                              _cache[16] || (_cache[16] = _createTextVNode("Show the team's rocks", -1))
                            ]),
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((section.hideBoard) = $event)
                              }, null, 8, _hoisted_42), [
                                [_vModelCheckbox, section.hideBoard]
                              ]),
                              _cache[17] || (_cache[17] = _createTextVNode("Hide the board", -1))
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("div", {
                    class: "template-addlink",
                    onClick: ($event: any) => (t.Sections.push(_ctx.newSection()))
                  }, "+ Add Section", 8, _hoisted_43),
                  _createElementVNode("input", {
                    class: _normalizeClass(t._saving ? 'disable-button' : ''),
                    type: "submit",
                    value: "Save Template",
                    onClick: ($event: any) => (_ctx.saveTemplate(t))
                  }, null, 10, _hoisted_44)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", {
            class: "add-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addTemplate()))
          }, "+ Add Template")
        ])
      ])
    ], 2),
    (_ctx.columnPendingRemoval)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeColumnConfirmed())),
          onCancel: _cache[3] || (_cache[3] = () => { _ctx.columnPendingRemoval = null; }),
          msg: "This column has default items on it - remove it and its items?"
        }))
      : _createCommentVNode("", true),
    (_ctx.templatePendingDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 1,
          onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteTemplateConfirmed())),
          onCancel: _cache[5] || (_cache[5] = () => { _ctx.templatePendingDelete = null; }),
          msg: _ctx.deleteTemplateConfirmMsg
        }, null, 8, ["msg"]))
      : _createCommentVNode("", true)
  ]))
}